import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ProblemDetails } from '../services/application-api.service'; // adjust path to your generated client
import { ApplicationInsightsService } from '../services/application-insights.service';
import { APP_CONFIG, AppConfiguration } from '../types/app-configuration';
import { SnackBarService } from '../services/snackbar.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private appInsightsService: ApplicationInsightsService,
    @Inject(APP_CONFIG) private config: AppConfiguration,
    private snackbarService: SnackBarService
  ) {}

  handleError(error: any): void {
    if (error && typeof error === 'object' && 'title' in error && 'status' in error) {
      const problem = error as ProblemDetails;

      if (problem && problem.title) {
        // Log or display to user
        console.error('API Problem:', problem);

        this.snackbarService.problem(problem);
      } else {
        console.error('API Error:', error);
      }
    } else {
      // Non-API errors
      console.error('Unexpected Error:', error);
      this.snackbarService.error('An unexpected error occurred: ' + (error?.message || error?.toString()));
    }

    if (!this.config.production) {
      this.appInsightsService.logException(error); // log to app insights
    }
  }
}
